// extracted by mini-css-extract-plugin
module.exports = {"Calculator":"style_Calculator__3gcXf"};